"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _Info = _interopRequireDefault(require("../Info"));

var _Checkbox = _interopRequireDefault(require("./Checkbox"));

var _StringOrRender = _interopRequireDefault(require("../helper/StringOrRender"));

var _styling = require("../../toolkit/styling");

var _providers = require("../../toolkit/providers");

var _Popover = _interopRequireDefault(require("../Popover"));

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var CheckboxField = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(CheckboxField, _Component);

  var _super = _createSuper(CheckboxField);

  function CheckboxField(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, CheckboxField);
    _this = _super.call(this, props);
    _this.context = void 0;
    _this.checkboxRef = void 0;
    _this.checkboxRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  (0, _createClass2["default"])(CheckboxField, [{
    key: "renderDescriptionTooltip",
    value: function renderDescriptionTooltip() {
      var _this$props = this.props,
          description = _this$props.description,
          popoverPosition = _this$props.popoverPosition,
          disabled = _this$props.disabled,
          checked = _this$props.checked,
          onChange = _this$props.onChange,
          title = _this$props.title,
          icon = _this$props.icon,
          wrapTitle = _this$props.wrapTitle,
          popoverProps = (0, _objectWithoutProperties2["default"])(_this$props, ["description", "popoverPosition", "disabled", "checked", "onChange", "title", "icon", "wrapTitle"]);

      if (!description) {
        return null;
      }

      return /*#__PURE__*/_react["default"].createElement(_Info["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.descriptionTooltip),
        text: description,
        position: popoverPosition || "top center"
      }, popoverProps));
    }
  }, {
    key: "renderContent",
    value: function renderContent() {
      var _this$props2 = this.props,
          title = _this$props2.title,
          children = _this$props2.children;

      if (title) {
        return /*#__PURE__*/_react["default"].createElement("label", {
          className: (0, _styling.css)(this.styles.title)
        }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
          value: title
        }));
      }

      return children;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          icon = _this$props3.icon,
          checked = _this$props3.checked,
          disabled = _this$props3.disabled,
          onChange = _this$props3.onChange,
          className = _this$props3.className,
          style = _this$props3.style;
      var rootCSS = (0, _styling.css)(this.styles.root, style, className);

      var Icon = function Icon() {
        if (!icon) {
          return null;
        }

        if (typeof icon == "function") {
          return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, icon());
        }

        return /*#__PURE__*/_react["default"].createElement("img", {
          src: icon,
          alt: "wish express",
          className: (0, _styling.css)(_this2.styles.icon)
        });
      };

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootCSS,
        style: style,
        onClick: function onClick() {
          var _this2$checkboxRef$cu;

          (_this2$checkboxRef$cu = _this2.checkboxRef.current) === null || _this2$checkboxRef$cu === void 0 ? void 0 : _this2$checkboxRef$cu.click();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
        ref: this.checkboxRef,
        checked: checked,
        disabled: disabled,
        onChange: onChange,
        className: (0, _styling.css)(this.styles.checkbox)
      }), /*#__PURE__*/_react["default"].createElement(Icon, null), this.renderContent(), this.renderDescriptionTooltip());
    }
  }, {
    key: "styles",
    get: function get() {
      var _this$context$theming = this.context.theming,
          textDark = _this$context$theming.theme.textDark,
          fonts = _this$context$theming.fonts;
      var _this$props4 = this.props,
          disabled = _this$props4.disabled,
          wrapTitle = _this$props4.wrapTitle;
      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          textAlign: "left",
          userSelect: "none",
          transition: "opacity 0.2s linear",
          cursor: disabled ? "default" : "pointer",
          fontFamily: fonts.regular
        },
        checkbox: {
          marginRight: 10
        },
        title: {
          fontSize: 16,
          color: textDark,
          overflow: "hidden",
          cursor: disabled ? "default" : "pointer",
          whiteSpace: wrapTitle ? "normal" : "nowrap",
          textOverflow: !wrapTitle ? "ellipsis" : undefined,
          wordWrap: wrapTitle ? "break-word" : undefined
        },
        icon: {
          height: 16,
          marginRight: 6
        },
        content: {},
        descriptionTooltip: {
          marginLeft: 5
        }
      });
    }
  }]);
  return CheckboxField;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = _objectSpread({
  title: {
    required: false,
    defaultValue: "null",
    type: "string | ((() => ReactNode)",
    description: "Title of the checkbox field. Either specify this or " + "render as child for custom content: " + "`<CheckboxField>title</CheckboxField>`"
  },
  icon: {
    required: false,
    defaultValue: "null",
    type: "?(string | ((() => ReactNode))",
    description: "Icon image of the checkbox field."
  },
  description: {
    required: false,
    type: "(string | null)",
    defaultValue: "null",
    description: "Description of the field; placed inside a tooltip"
  },
  wrapTitle: {
    required: false,
    type: "boolean",
    defaultValue: "false",
    description: "Indicates that the title text should wrap when its overflows. " + "Otherwise it ellipsizes."
  }
}, _Popover["default"].propDoc), _class3.demoProps = {
  title: "I agree to Wish's Terms of Service",
  onChange: function onChange() {},
  checked: false
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype)), _class2)) || _class;

var _default = CheckboxField;
exports["default"] = _default;